//for local
// const url = '';
// for test
const url = process.env.VUE_APP_URL;
const image_url = process.env.VUE_APP_IMAGE_URL;
export default {
  image_url: image_url,
  user_restaurant: url + '/v1/mgr/stat/restaurant', // 门店信息1 销售额 get/xxxxx
  user_status_a: url + '/v1/mgr/employee/status', // 获取员工信息 get
  user_status_employees: url + '/1/shop/employees', // 获取员工信息列表
  // user_menu_list: url + '/v1/mgr/menu/list',// 获取菜单列表
  user_menu_dinners: url + '/v1/mgr/menu/dinners', // 获取餐时列表?restaurant_id=10000&start_date=20200426&end_date=20200606
  user_menu_cuisines_push: url + '/v1/mgr/menu/cuisine',
  user_menu_labels: url + '/v1/mgr/menu/labels',
  user_menu_label: url + '/v1/mgr/menu/label',
  user_menu_statistic: url + '/v1/mgr/menu/dishes/statistic',
  user_menu_dish_unit: url + '/v1/mgr/common/data-dictionaries/dish_unit',
  user_menu_search: url + '/v1/mgr/menu/dishes/search',
  user_menu_ingredients: url + '/v1/mgr/menu/ingredients',

  user_login: url + '/1/account/login/user', // 登录
  user_login_subUser: url + '/1/account/login/subUser', // 子账号登录

  user_restaurants: url + '/1/shop', // 门店信息2 信息 get/xxxxx PUT 修改信息
  user_company: url + '/1/account/company', // 创建公司和超级管理员账号
  user_invite_code: url + '/1/account/invite_code/new', // 创建邀请码
  user_semployee_new: url + '/1/shop/employee', // 获取单个员工信息 修改put
  user_upload_shot: url + '/1/file/bg/upload/shot',
  user_status_qiniutoken: url + '/1/file/upload/token', //获取7牛touken
  user_status_qiniutoken_dish: url + '/1/file/upload/open/token/dish', //获取7牛无加密touken

  user_restaurant_list: url + '/1/shop/list', //获取公司门店列表

  user_restaurant_push: url + '/v1/mgr/v1/mgr/restaurant', // 新建店铺

  user_menu_cuisines: url + '/1/dish/category/list', // 类目列表
  user_menu_cuisines_platform: url + '/1/platform_dish/category/list',

  user_menu_cuisines_list: url + '/1/dish/category', // post 新增类目  get单个信息
  user_menu_cuisines_list_platform: url + '/1/platform_dish/category', // post 新增类目  get单个信息

  user_menudish_attr_list: url + '/1/dish/dish_attr/list', // /0/1?shop_id=25884083765760获取标签列表
  user_menudish_attr_list_platform: url + '/1/platform_dish/dish_attr/list', // /0/1?shop_id=25884083765760获取标签列表

  user_menudish_attr: url + '/1/dish/dish_attr', //shopId 新增餐炉post  put修改餐炉  delete删除餐炉
  user_menudish_attr_platform: url + '/1/platform_dish/dish_attr', //shopId 新增餐炉post  put修改餐炉  delete删除餐炉

  user_dish_list: url + '/1/dish/list', ///0/2?name=肉&category_ids&dish_attr_value_ids&shop_id获取菜品列表
  user_dish_list_platform: url + '/1/platform_dish/list',

  shop_coupon_list: url + '/1/coupon/',
  create_coupon: url + '/1/coupon',
  send_coupon: url + '/1/coupon/send/',
  delete_coupon: url + '/1/coupon/delete/',
  discard_coupon: url + '/1/coupon/discard/',

  user_dish_attr: url + '/1/dish', //shopId post新增菜品  put修改菜品  delete删除菜品
  user_dish_attr_platform: url + '/1/platform_dish',
  copy_dish_platform_url: url + '/1/platform_dish/copyall/',
  copy_dish_platform_log: url + '/1/platform_dish/job/logs/',

  user_category_dish: url + '/1/dish/category_dish', //shopId post新增菜品  put修改菜品  delete删除菜品
  user_category_dish_platform: url + '/1/platform_dish/category_dish', //shopId post新增菜品  put修改菜品  delete删除菜品

  user_device_dish: url + '/1/dish/today_dish/list', //get每日菜品
  user_device_dish_platform: url + '/1/platform_dish/today_dish/list',

  user_device_list: url + '/1/device/list', //shopId 获取餐炉列表
  user_device_set: url + '/1/device', //shopId 新增餐炉post  put修改餐炉  delete删除餐炉

  copy_platform_dish: url + '/1/platform_dish/copy/',

  user_dish_unit: url + '/1/dish/dish_unit/list', //获取菜品单位
  user_dish_unit_platform: url + '/1/platform_dish/dish_unit/list',

  user_dish_raw: url + '/1/dish/dish_raw/list',
  user_dish_raw_platform: url + '/1/platform_dish/dish_raw/list',

  user_dish_raw_create: url + '/1/dish/dish_raw',
  user_dish_raw_platform_create: url + '/1/platform_dish/dish_raw',

  user_dish_unit_3: url + '/1/dish/dish_unit', //菜品单位
  user_dish_unit_3_platform: url + '/1/platform_dish/dish_unit',

  user_dish_raw_byid: url + '/1/dish/dish_raw', //菜品单位
  user_dish_raw_platform_byid: url + '/1/platform_dish/dish_raw', //菜品单位

  user_dish_attr_value: url + '/1/dish/dish_attr_value', //菜品属性值
  user_dish_attr_value_platform: url + '/1/platform_dish/dish_attr_value', //菜品属性值

  user_dish_attr_map: url + '/1/dish/dish_attr_map', //关联菜品属性
  user_dish_attr_map_platform: url + '/1/dish/dish_attr_map', //关联菜品属性

  user_order_search: url + '/1/order/eat_in/search', //获取堂食订单
  user_order_search_vip: url + '/1/order/prepay/search', //会员充值记录
  user_order_search_refund: url + '/1/order/refund/search', //退款列表
  user_order_search_refund_value: url + '/1/order/refund', //退款详情
  user_order_search_refund_confirm: url + '/1/order/refund/confirm', //退款确认

  user_order_detail: url + '/1/order/eat_in/detail', //获取堂食订单详情
  user_order_takeout_search: url + '/1/order/takeout/search', //获取外卖订单
  user_order_takeout_detail: url + '/1/order/takeout/detail', //获取外卖订单详情
  user_common_data: url + '/1/common-data/list', //获取通用状态
  user_account_user: url + '/1/account/user', //获取登录用户基本信息
  user_account_company: url + '/1/account/company', //获取公司基本信息
  user_account_password: url + '/1/account/user/password', //修改用户密码

  user_dish_base: url + '/1/dish/dish_base/list', //搜索基础菜品
  user_dish_base_platform: url + '/1/platform_dish/dish_base/list', //搜索基础菜品

  user_label_list: url + '/1/dish/label/list', //门店标签属性
  user_label_list_platform: url + '/1/platform_dish/label/list', //门店标签属性

  user_user_roles: url + '/1/shop/user_roles', //获取公司子账号角色列表
  user_user_list: url + '/1/shop/user', //获取公司子账号列表
  user_user_role: url + '/1/shop/user_role', //删除子账号角色
  user_user_password: url + '/1/shop/user/password', //修改子账号密码
  user_kitchen: url + '/1/statistic/kitchen', //后厨中心

  user_menu_dish_list: url + '/1/dish/menu_dish/list', //获取菜单菜品
  user_menu_dish_list_platform: url + '/1/platform_dish/menu_dish/list',

  user_menu_list: url + '/1/dish/menu/list', //获取菜单列表
  user_menu_list_platform: url + '/1/platform_dish/menu/list', //获取菜单列表

  user_menu: url + '/1/dish/menu', //新建菜单
  user_menu_platform: url + '/1/platform_dish/menu', //新建菜单

  user_menu_dish: url + '/1/dish/menu_dish', //新建菜单菜品
  user_menu_dish_platform: url + '/1/platform_dish/menu_dish', //新建菜单菜品

  user_menu_dish_unit_price: url + '/1/dish/dish_unit_price', //修改菜价
  user_menu_dish_unit_price_platform: url + '/1/platform_dish/dish_unit_price', //修改菜价

  user_menu_active: url + '/1/dish/menu/active', //修改菜价
  user_menu_active_platform: url + '/1/platform_dish/menu/active', //修改菜价

  show_indicator: url + '/1/statistic/indicator',
  show_dish_indicator: url + '/1/statistic/dish/indicator',
  stove_weight: url + '/1/order/stoves/',

  user_vip_list: url + '/1/magcard/list', //获取会员列表
  user_vip_add: url + '/1/magcard', //新增、编辑会员
  user_history_list: url + '/1/magcard/history/0', //获取充值记录
  user_cardHistory_list: url + '/1/magcard/history/', //消费历史记录
  user_cardRecharge: url + '/1/magcard/recharge', //充值
  user_cardRCharge: url + '/1/magcard/charge', //消费
  user_stateCharge: url + '/1/magcard/status', //更改用户状态

  add_revenue: url + '/1/order/revenue',
  search_revenue: url + '/1/order/revenue',
  delete_revenue: url + '/1/order/revenue',


  update_receipt: url + '/1/device/receipt',
  fetch_receipt: url + '/1/device/receipt',


};
